import {IServiceFactory} from '../../service-factory.interface';

export class CmsLink {
  constructor(private _anchorElement: HTMLAnchorElement, private _cmsContentRootElement: HTMLElement, private _services: IServiceFactory) {
    this._clickHandler = this._clickHandler.bind(this);
    this._anchorElement.addEventListener('click', this._clickHandler);
  }

  private _clickHandler(event) {
    event.preventDefault();
    let anchorUri = this._services.location.tryParseUrl(this._anchorElement.href);
    let currentUri = this._services.location.currentUri;

    if(currentUri.origin === anchorUri.origin
      && currentUri.pathName.equals(anchorUri.pathName)
      && !anchorUri.hash.isEmpty) { // if the anchor href refers to the current route and there is a hash in the anchor href then we need to scroll into view an element with id = #hash
      let element = this._cmsContentRootElement.querySelector(anchorUri.hash.toString());
      if(element) {
        element.scrollIntoView();
      }
    } else {
      this._services.location.push(this._anchorElement.href);
    }
  };


  dispose() {
    this._anchorElement.removeEventListener('click', this._clickHandler);
  }

}
